<div *ngIf="this.campaign.account.isHubStandardCampaign" class="mb-3">
    <span class="mb-3 ml-3 edge-text-secondary items-baseline gap-2"><strong>Google Adwords Ads &nbsp;&nbsp;</strong></span>
    <creative-status-indicator [creativeStatusId]="creative.creativeStatusId" [creativeBulidStatusId]="creative.creativeStatusBuildId" [campaignType]="campaign.campaignType"></creative-status-indicator>
</div>
<div class="pl-3" [ngClass]="this.currentUser.permissions.isLearfieldClient ? 'left-border ml-5' : ''">
    <div *ngIf="!this.campaign.account.isHubStandardCampaign || ((creative.name || creative.budget) && this.campaign.account.isHubStandardCampaign)" class="my-3 row align-items-center ml-0 py-3 creative-border">
        <div class="col-lg-9 col-12 px-2 d-flex" style="flex-direction: column;">
            <div *ngIf="!!creative.name">
                <label class="my-0 font-weight-bold pl-3">{{this.creative.name}}</label>
                <label class="my-0" *ngIf="functions.checkAreDatesVisible(creative.flightStartDate, creative.flightEndDate, campaign.startDate, campaign.endDate, creative.creativeGroup, campaign.creatives, campaign.campaignType).isVisible">{{functions.checkAreDatesVisible(creative.flightStartDate, creative.flightEndDate, campaign.startDate, campaign.endDate, creative.creativeGroup, campaign.creatives, campaign.campaignType).datesLabel}}</label>
                <creative-budget *ngIf = "campaign.campaignType == enumAccountType.HS && !this.currentUser.permissions.isClient" [creative]="creative"  style="display: ruby;"></creative-budget>

                &nbsp;&nbsp;
                <creative-status-indicator *ngIf="!this.campaign.account.isHubStandardCampaign" [creativeStatusId]="creative.creativeStatusId" [creativeBulidStatusId]="creative.creativeStatusBuildId" [campaignType]="campaign.campaignType"></creative-status-indicator>
            </div>
            <!-- <div *ngIf="creative.budget != null">
                <label class="my-0 font-weight-bold pl-3">Budget: </label>
                <label class="my-0" style="margin-left: 5px;">{{creative.budget}}$</label>
            </div> -->
        </div>
    </div>

    <!-- <div *ngIf="!isUploadOk" class="mb-3 mt-3 row ml-0 invalid-message-box d-flex align-items-center" style="min-height: 3em;">
        <span class="pl-3">Incorrect file type or incorrect file dimensions or incorrect file size.</span>
    </div> -->
    <div class="mb-4 mt-3 pt-3">


        <div class="row align-items-center">
            <div class="col-lg-2 col-12">
                <label><strong>Headline 1</strong></label>
            </div>
            <div class="col-lg-10 col-12">
                <div class="row">
                    <div class="col-12">
                        <label *ngIf="reviewPage" class="mr-0 pr-0">{{creative.detailJson.headline}}</label>
                        <div class="input-group" *ngIf="!reviewPage">
                            <input class="form-control" type="text" [maxlength]=30 [(ngModel)]="creative.detailJson.headline" [title]="creative.detailJson.headline" style="overflow: hidden; text-overflow: ellipsis;" [disabled]="!functions.checkCanChangeAsset(creative, campaign.startDate, campaign.campaignStatusId, campaign.statusId, campaign.campaignType, currentUser, !!campaign.campaignInventoryItems ? campaign.campaignInventoryItems[0] : null, maxNumberOfFlights)">
                            <label class="input-group-append d-flex align-items-center justify-content-center px-2">{{30-creative.detailJson.headline.length}} CHARACTERS LEFT</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row align-items-center">
            <div class="col-lg-2 col-12">
                <label><strong>Headline 2</strong></label>
            </div>
            <div class="col-lg-10 col-12">
                <div class="row">
                    <div class="col-12">
                        <label *ngIf="reviewPage" class="mr-0 pr-0">{{creative.detailJson.headline2}}</label>
                        <div class="input-group" *ngIf="!reviewPage">
                            <input class="form-control" type="text" [maxlength]=30 [(ngModel)]="creative.detailJson.headline2" [title]="creative.detailJson.headline2" style="overflow: hidden; text-overflow: ellipsis;" [disabled]="!functions.checkCanChangeAsset(creative, campaign.startDate, campaign.campaignStatusId, campaign.statusId, campaign.campaignType, currentUser, !!campaign.campaignInventoryItems ? campaign.campaignInventoryItems[0] : null, maxNumberOfFlights)">
                            <label class="input-group-append d-flex align-items-center justify-content-center px-2">{{30-creative.detailJson.headline2.length}} CHARACTERS LEFT</label>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="row align-items-center">
            <div class="col-lg-2 col-12">
                <label><strong>Description</strong></label>
            </div>
            <div class="col-lg-10 col-12">
                <div class="row">
                    <div class="col-12">
                        <label *ngIf="reviewPage">{{creative.detailJson.linkDescription}}</label>
                        <div class="input-group" *ngIf="!reviewPage">
                            <input class="form-control" *ngIf="!reviewPage" type="text" [maxlength]=80 [(ngModel)]="creative.detailJson.linkDescription" [title]="creative.detailJson.linkDescription" style="overflow: hidden; text-overflow: ellipsis;" [disabled]="!functions.checkCanChangeAsset(creative, campaign.startDate, campaign.campaignStatusId, campaign.statusId, campaign.campaignType, currentUser, !!campaign.campaignInventoryItems ? campaign.campaignInventoryItems[0] : null, maxNumberOfFlights)">
                            <label class="input-group-append d-flex align-items-center justify-content-center px-2">{{80-creative.detailJson.linkDescription.length}} CHARACTERS LEFT</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row align-items-center">
            <div class="col-lg-2 col-12">
                <label><strong>Path 1</strong></label>
            </div>
            <div class="col-lg-10 col-12">
                <div class="row mb-2">
                    <div class="col-12">
                        <label *ngIf="reviewPage" class="mr-0 pr-0">{{creative.detailJson.path1}}</label>
                        <div class="input-group" *ngIf="!reviewPage">
                            <input class="form-control" *ngIf="!reviewPage" type="text" [maxlength]=15 [(ngModel)]="creative.detailJson.path1" [title]="creative.detailJson.path1" style="overflow: hidden; text-overflow: ellipsis;" [disabled]="!functions.checkCanChangeAsset(creative, campaign.startDate, campaign.campaignStatusId, campaign.statusId, campaign.campaignType, currentUser, !!campaign.campaignInventoryItems ? campaign.campaignInventoryItems[0] : null, maxNumberOfFlights)">
                            <label class="input-group-append d-flex align-items-center justify-content-center px-2">{{15-creative.detailJson.path1.length}} CHARACTERS LEFT</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row align-items-center">
            <div class="col-lg-2 col-12">
                <label><strong>Path 2</strong></label>
            </div>
            <div class="col-lg-10 col-12">
                <div class="row">
                    <div class="col-12">
                        <label *ngIf="reviewPage" class="mr-0 pr-0">{{creative.detailJson.path2}}</label>
                        <div class="input-group" *ngIf="!reviewPage">
                            <input class="form-control" type="text" [maxlength]=15 [(ngModel)]="creative.detailJson.path2" [title]="creative.detailJson.path2" style="overflow: hidden; text-overflow: ellipsis;" [disabled]="!functions.checkCanChangeAsset(creative, campaign.startDate, campaign.campaignStatusId, campaign.statusId, campaign.campaignType, currentUser, !!campaign.campaignInventoryItems ? campaign.campaignInventoryItems[0] : null, maxNumberOfFlights)">
                            <label class="input-group-append d-flex align-items-center justify-content-center px-2">{{15-creative.detailJson.path2.length}} CHARACTERS LEFT</label>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="row align-items-center mb-2">
            <div class="col-lg-2 col-12">
                <label><strong>Display URL</strong></label>
            </div>
            <div class="col-lg-10 col-12">
                <input class="form-control" *ngIf="!reviewPage" type="text" [(ngModel)]="creative.detailJson.displayUrl" [title]="isLandingUrlOk == false ? titleWrongUrl : creative.detailJson.displayUrl" style="overflow: hidden; text-overflow: ellipsis;" [ngClass]="this.isLandingUrlOk == false ? 'border-wrong' : ''" (focusout)="validationLandingPageMessage()" [disabled]="!functions.checkCanChangeAsset(creative, campaign.startDate, campaign.campaignStatusId, campaign.statusId, campaign.campaignType, currentUser, !!campaign.campaignInventoryItems ? campaign.campaignInventoryItems[0] : null, maxNumberOfFlights)">
                <label *ngIf="reviewPage" class="mr-0 pr-0">{{creative.detailJson.displayUrl}}</label>
            </div>
        </div>

        <div class="row align-items-center mb-2">
            <div class="col-lg-2 col-12">
                <label><strong>Ad Group</strong></label>
            </div>
            <div class="col-lg-10 col-12">
                <input class="form-control" *ngIf="!reviewPage" type="text" [(ngModel)]="creative.detailJson.adGroup" [title]="creative.detailJson.adGroup" style="overflow: hidden; text-overflow: ellipsis;" [disabled]="!functions.checkCanChangeAsset(creative, campaign.startDate, campaign.campaignStatusId, campaign.statusId, campaign.campaignType, currentUser, !!campaign.campaignInventoryItems ? campaign.campaignInventoryItems[0] : null, maxNumberOfFlights)">
                <label *ngIf="reviewPage" class="mr-0 pr-0">{{creative.detailJson.adGroup}}</label>
            </div>
        </div>
    </div>

    <!-- <div class="mb-4" [ngClass]="isApprove? 'col-8':'col-4'">
        <file-upload (openPreviewEvent)="openPreview($event)" [reviewPage]='reviewPage' [isApprovedReported]='creative.creativeAssets[0].isValid!=null' [isApprove]='isApprove' filetypes="mp4" size=30000000 [footer]='booleanFalse' [campaign]="this.campaign" [creativeId]="creative.creativeAssets[0].creativeId" type="video" [asset]="0"></file-upload>

    </div> -->
</div>